
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-camera-line',
      title: 'أنظمة كاميرات المراقبة',
      description: 'كاميرات عالية الدقة مع تقنيات الرؤية الليلية والتسجيل المستمر لمراقبة شاملة على مدار الساعة.',
    },
    {
      icon: 'ri-fingerprint-line',
      title: 'أنظمة التحكم في الدخول',
      description: 'أنظمة بصمة وبطاقات ذكية للتحكم الكامل في دخول وخروج الموظفين والزوار بأمان تام.',
    },
    {
      icon: 'ri-door-open-line',
      title: 'البوابات والأبواب الأمنية',
      description: 'بوابات أمنية ذكية وأبواب إلكترونية متطورة لحماية المداخل والمخارج الرئيسية.',
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'أنظمة الإنذار والحريق',
      description: 'أنظمة إنذار متقدمة للكشف المبكر عن الحرائق والتسلل مع إشعارات فورية.',
    },
    {
      icon: 'ri-router-line',
      title: 'الشبكات والبنية التحتية',
      description: 'حلول شبكات متكاملة وبنية تحتية قوية لربط جميع الأنظمة الأمنية بكفاءة عالية.',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'الصيانة والدعم الفني',
      description: 'خدمات صيانة دورية ودعم فني متواصل لضمان عمل الأنظمة بكفاءة مثالية.',
    },
  ];

  return (
    <section className="py-24 bg-silver-light/40">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary bg-primary/5 mb-6">
            <span className="text-sm font-semibold text-primary">خدماتنا المتكاملة</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-navy-light mb-6">
            حلول أمنية شاملة لكل احتياجاتك
          </h2>
          <p className="text-lg text-gray-dark max-w-2xl mx-auto">
            نقدم مجموعة متكاملة من الخدمات الأمنية المتطورة لحماية منشآتك بأعلى معايير الجودة
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-10 shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer border border-silver/30"
            >
              {/* Icon */}
              <div className="w-[70px] h-[70px] flex items-center justify-center rounded-xl bg-primary/8 mb-6 group-hover:bg-primary transition-all duration-300">
                <i className={`${service.icon} text-3xl text-primary group-hover:text-white transition-all duration-300`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold text-navy-light mb-4 group-hover:text-primary transition-all duration-300">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-gray-dark text-[15px] leading-relaxed mb-6">
                {service.description}
              </p>

              {/* Link */}
              <Link
                to="/products"
                className="inline-flex items-center gap-2 text-primary text-[15px] font-semibold hover:gap-3 transition-all duration-300"
              >
                <span>اعرف المزيد</span>
                <i className="ri-arrow-left-line"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
